import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const Section = ({
  title,
  count,
  children,
  icon,
  summary,
  className = '',
  borderTop = false,
  variant = 'primary',
  collapsible = false,
  defaultOpen = true,
}) => {
  const [open, setOpen] = useState(defaultOpen);

  if (variant !== 'primary') {
    return (
      <div className="shadow-[0_1px_3px_rgba(0,0,0,.04)] w-full bg-white dark:bg-card rounded-xl border border-border p-6">
        {title && (
          <div className="flex items-center gap-3 border-b border-border pb-2">
            <div className="grid h-10 w-10 place-items-center rounded-xl bg-brand-bg-subtle ring-1 ring-[#99F6E4]">
              {icon && <span>{icon}</span>}
            </div>
            <div>
              <div className="text-md font-semibold text-foreground-strong">
                {title}
              </div>
            </div>
          </div>
        )}
        <div className="mt-4">{children}</div>
      </div>
    );
  }

  const wrapperCls = `shadow-[0_1px_3px_rgba(0,0,0,.04)] w-full bg-white dark:bg-card rounded-xl border border-border overflow-hidden ${
    collapsible ? '' : 'p-6'
  } ${className} ${borderTop ? 'border-t-4 border-t-primary' : ''}`;

  const titleNode = (
    <h3 className="text-foreground-strong font-semibold md:text-md pageTitle flex items-center">
      {icon && <span className="mr-2">{icon}</span>}
      {title}
    </h3>
  );

  const countBadge = count ? (
    <span className="text-xs font-semibold text-muted-foreground bg-border px-2 py-1 rounded-xl">
      {count}
    </span>
  ) : null;

  if (collapsible) {
    return (
      <div className={wrapperCls}>
        {title && (
          <button
            type="button"
            onClick={() => setOpen((o) => !o)}
            aria-expanded={open}
            className="w-full flex items-center gap-2.5 px-5 py-[15px] text-left hover:bg-muted/40 transition-colors"
          >
            {icon && (
              <span className="w-5 h-5 flex items-center justify-center text-muted-foreground flex-shrink-0">
                {icon}
              </span>
            )}
            <h3 className="text-foreground-strong font-semibold text-[14px] tracking-[-0.01em] flex-shrink-0">
              {title}
            </h3>
            {!open && summary ? (
              <span className="flex-1 min-w-0 text-right text-[12.5px] text-muted-foreground truncate">
                {summary}
              </span>
            ) : (
              <span className="flex-1" />
            )}
            {countBadge}
            <ChevronDown
              className={`w-4 h-4 text-muted-foreground transition-transform flex-shrink-0 ${
                open ? '' : '-rotate-90'
              }`}
              strokeWidth={2}
            />
          </button>
        )}
        {open && (
          <div className="px-5 pb-5 pt-[18px] border-t border-border">
            {children}
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={wrapperCls}>
      {title && (
        <div className="flex items-center justify-between mb-4">
          {titleNode}
          {countBadge}
        </div>
      )}
      <div>{children}</div>
    </div>
  );
};

export default Section;
